import React from "react";
import { motion } from "framer-motion";
// import Heading from "../../components/Heading";
// import { GRAPHICS } from "../../constants/AssetsPath";
import { Box, Grid, Typography, Container } from "@mui/material";
import INCOMEPROTECTGRPHS from "../../assets/Graphics/IncomeProtect.png";

const PlanPurchaseProcess = () => {
  const INCOME_PROTECTION = [
    {
      number: 1,
      title: "Loss of Job Coverage",
      description: "Support when you’re unexpectedly unemployed.",
    },
    {
      number: 2,
      title: "Disability Income Insurance",
      description:
        "Protect your earnings if illness or injury prevents you from working.",
    },
    {
      number: 3,
      title: "Short-Term Income Replacement",
      description: "Stay financially stable during brief periods of work loss.",
    },
    {
      number: 4,
      title: "Long-Term Security Plan",
      description: "Sustain your lifestyle during extended absences from work.",
    },
    {
      number: 5,
      title: "Family Income Benefit",
      description: "Ensure your family’s needs are met even if you can’t earn.",
    },
    {
      number: 6,
      title: "Self-Employed Protection",
      description: "Tailored plans for freelancers and business owners.",
    },
  ];
  return (
    <Box
      sx={{
        backgroundColor: "#fff6f1",
        marginTop: "0rem",
        paddingTop: "2rem",
        paddingBottom: "03rem",
      }}
    >
      <Box align="center" mb={2}>
        {/* <Heading title="What is Income Protection" /> */}
        <h4 className="main-heading-font-size ">What is Income Protection</h4>
      </Box>
      <Container maxWidth="lg">
        <Grid container spacing={8} alignItems="center">
          <Grid item xs={12} md={6} sx={{ maxWidth: 450 }}>
            <motion.div
              initial={{ x: -100, opacity: 0 }}
              whileInView={{ x: 0, opacity: 1 }}
              transition={{ duration: 1 }}
            >
              <Grid item xs={12} md={6}>
                <Grid container spacing={2}>
                  <Grid
                    item
                    xs={12}
                    md={5}
                    display="flex"
                    justifyContent="flex-end"
                  >
                    <Box
                      component="img"
                      src={INCOMEPROTECTGRPHS}
                      alt="Career Puzzle"
                      sx={{
                        width: { xs: "100%", sm: "80%", md: "100%" },
                        maxHeight: "400px",
                        objectFit: "contain",
                      }}
                    />
                  </Grid>
                </Grid>
              </Grid>
            </motion.div>
          </Grid>

          <Grid item xs={12} md={6} ml={{ xs: 2, md: 0 }}>
            <motion.div
              initial={{ x: 100, opacity: 0 }}
              whileInView={{ x: 0, opacity: 1 }}
              transition={{ duration: 1 }}
            >
              {INCOME_PROTECTION.map((step) => (
                <Box key={step.number} sx={{ display: "flex", mb: 1 }}>
                  <motion.div
                    initial={{ x: 100, opacity: 0 }}
                    whileInView={{ x: 0, opacity: 1 }}
                    transition={{ duration: 1 }}
                  >
                    <Box display={"flex"}>
                      <Box
                        sx={{
                          bgcolor: "green",
                          color: "white",
                          width: 8,
                          height: 8,
                          borderRadius: "50%",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          fontFamily: '"Poppins", serif',
                          fontSize: { xs: "0.5rem" },
                          mt: { xs: "1.6rem", sm: "1.6rem", md: "1.6rem" },
                          // mt: 1,
                          mr: 2,
                        }}
                      ></Box>

                      <Box sx={{ px: 1 }}>
                        <Typography
                          fontWeight="600"
                          sx={{
                            fontFamily: '"Poppins", serif',
                            fontSize: { xs: "0.9rem", md: "0.96rem" },
                            mt: { xs: "1rem", sm: "1rem", md: "1rem" },
                          }}
                        >
                          {step.title}
                        </Typography>

                        <Typography
                          variant="body2"
                          sx={{
                            fontFamily: '"Poppins", serif',
                            fontSize: { xs: "0.85rem", md: "0.9rem" },
                            mt: { xs: "0.6rem", sm: "0.6rem", md: "0.6rem" },
                          }}
                        >
                          {step.description}
                        </Typography>
                      </Box>
                    </Box>
                  </motion.div>
                </Box>
              ))}
            </motion.div>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default PlanPurchaseProcess;
